// extracted by mini-css-extract-plugin
module.exports = {"topComment":"_1mZX2","topCommentLabel":"_2fKtD"};